<template>
    <empire-select
        title="Select Practitioner"
        :disabled="users.length == false"
        :inputClass="{ 'is-loading': users.length == false }"
        :fieldClass="fieldClass"
        :label="label"
        :options="users"
        valueFrom="id"
        @input="$emit('input', $event)"
        v-bind="$attrs"
        :value="value"
        data-testid="select-practitioner"
    />
</template>

<script>
import Select from 'component/revamp/elements/Select';
import { computed, onMounted, defineComponent } from '@vue/composition-api';
import useUserDropdowns from 'use/partials/usersDropdown';
import { useStore } from 'use/store';
import useCurrentUser from 'use/currentUser';

export default defineComponent({
    components: {
        'empire-select': Select,
    },
    props: {
        label: {
            type: String,
            default: 'Practitioner',
        },
        facilityId: {
            type: [Number, String],
        },
        enforceUserWhitelist: {
            type: Boolean,
            default: false,
        },
        fieldClass: {
            type: [String, Array, Object],
            default: 'column',
        },
        value: {},
    },
    setup(props, { emit }) {
        const { currentUserIsFacility, currentUser } = useCurrentUser();

        const store = useStore();
        const users = computed(() => {
            let { activePractitioners } = useUserDropdowns();
            let practitioners = activePractitioners?.value || [];
            practitioners = practitioners.filter((practitioner) => practitioner.facility_id == props.facilityId);

            if (currentUserIsFacility.value && props.enforceUserWhitelist) {
                practitioners = practitioners.filter((user) => {
                    const userIndex = store.getters['shared/whitelistedUsers'].findIndex(
                        (whitelistedUser) => whitelistedUser.id == user.id
                    );
                    return userIndex !== -1 || user.id == currentUser.value.id;
                });
            }

            return practitioners;
        });

        onMounted(() => {
            emit('input', props.value || currentUser.value.defaultPractitionerId);
        });

        return {
            users,
        };
    },
});
</script>
